import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardOverviewComponent } from "./dashboard-overview/dashboard-overview.component";
import { BatterieDiagrammComponent } from "../report/shared/components/batterie-diagramm/batterie-diagramm.component";
import { MatCardModule } from "@angular/material/card";
import { SharedModule } from "../shared/shared.module";
import { FuellcellRemainingDiagrammComponent } from "./shared/components/fuellcell-remaining-diagramm/fuellcell-remaining-diagramm.component";
import { MatButtonModule } from "@angular/material/button";

@NgModule({

  declarations: [DashboardOverviewComponent, BatterieDiagrammComponent, FuellcellRemainingDiagrammComponent],
  imports: [CommonModule, MatCardModule, SharedModule, MatButtonModule],
  exports: [],
  providers: [],
})
export class DashboardModule { }
